import { UserRole } from '@prisma/client';
import { z } from 'zod';

export const SettingsSchema = z
    .object({
        firstName: z.string().min(1, 'Name must be at least 3 character long'),
        lastName: z.string().min(1, 'Name must be at least 3 character long'),
        name: z.string().optional(),
        isTwoFactorEnabled: z.boolean().optional(),
        role: z.nativeEnum(UserRole).optional(),
        email: z.string().email().optional(),
        image: z.string().optional(),
        password: z.string().optional(),
        newPassword: z.string().optional(),
    })
    .refine(
        (data) => {
            if (data.password && !data.newPassword) {
                return false;
            }
            if (!data.password && data.newPassword) {
                return false;
            }
            return true;
        },
        {
            path: ['password'],
            message: 'Password is required',
        }
    );

export const loginSchema = z.object({
    email: z.string().email({ message: 'Email is required' }),
    password: z.string().min(1, 'Password is required'),
    code: z.string().optional(),
});
export const registerSchema = z.object({
    firstName: z.string().min(1, 'Name must be at least 3 character long'),
    lastName: z.string().min(1, 'Name must be at least 3 character long'),
    email: z.string().email('Email must be a valid email address.'),
    password: z.string().min(1, 'Password must be at least 1 characters long'),
    confirmPassword: z
        .string()
        .min(1, 'Password must be at least 1 characters long'),
});

export const resetSchema = z.object({
    email: z.string().email({ message: 'Email is required' }),
});

export const newPasswordSchema = z.object({
    password: z.string().min(1, 'Minimum 6 characters required'),
    // confirmPassword: z.string().min(1, 'Minimum 6 characters required'),
});

// Define validation schemas
export const workspaceSchema = z
    .object({
        name: z.string().min(1, 'Name is required'),
        domain: z.string().optional(),
        autoJoin: z.boolean().optional(),
        hasCompanyEmail: z.boolean(),
    })
    .refine(
        (data) => {
            // If there is a company domain, domain and autoJoin should be required
            if (data.hasCompanyEmail) {
                return data.domain && data.autoJoin !== undefined;
            }
            return true;
        },
        {
            message: 'Domain and Auto-join are required for company domains',
            path: ['domain', 'autoJoin'],
        }
    );

// Update the channelSchema to include partnerDomains
export const partnerDomainSchema = z.object({
    partnerDomains: z.array(z.string()),
});

export const channelSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    description: z.string(),
    dateRange: z.object({
        from: z.date(),
        to: z.date(),
    }),
    eventDate: z.date(),
    partnerDomains: z.array(z.string()),
});

// export const invitationSchema = z.object({
//     invitations: z.array(
//         z.object({
//             id: z.string(),
//             firstName: z.string().min(1, 'First name is required'),
//             lastName: z.string().min(1, 'Last name is required'),
//             email: z.string().email('Invalid email address'),
//         })
//     ),
// });

// Add a single invitee validation schema
export const singleInviteeSchema = z.object({
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().min(1, 'Last name is required'),
    email: z.string().email('Invalid email address'),
});

// Combine all schemas for final validation
export const createWorkspaceSchema = z.object({
    userId: z.string(),
    workspace: workspaceSchema,
    // channel: channelSchema,
});

export const createChannelSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    workspaceId: z.string(),
    domain: z.string(),
    collaborationType: z.enum(['webinar', 'content', 'in-person']).optional(),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    eventStartDate: z.string().optional(),
    eventEndDate: z.string().optional(),
    timezone: z.string().optional(),
});
